// extracted by mini-css-extract-plugin
module.exports = {"label":"CondensedList_label__l6rhD","wrapper":"CondensedList_wrapper__sbWQA","headliner":"CondensedList_headliner__utkvN"};